import * as React from "react";
import EGoldHeaderNav from "egold/components/header";
import {RouteComponentProps, Link} from "react-router-dom";
import {IReduxState} from "reducers";
import {connect} from "react-redux";
import {indexPath, routePaths} from "egold/routes";
import {useEffect} from "react";
import {getTransactions} from "egold/actions";
import {vendor} from "egold/egold-config";
import {IEgoldUserDetails, IGoldTransactions} from "StateInterface";
import {imageBaseUrl} from "config";
import {capitalizeFirstLetter} from "utils";
import {convertUTCtoLocalString, HeaderTitle, renderEmptyMessage} from "egold/utils";

interface IConnectProps {
    dispatch?: (action: any) => void;
    transactions: IGoldTransactions[];
    eGoldUserDetails: IEgoldUserDetails;
    isAndroid: boolean;
}
function Orders(props: IConnectProps & RouteComponentProps) {
    useEffect(() => {
        window.scrollTo(0, 0);
        if (props.eGoldUserDetails) {
            props.dispatch(getTransactions(vendor.SAFEGOLD, props.eGoldUserDetails.vendor_id, 1));
        }
    }, [props.eGoldUserDetails]);
    return(
        <div className="add-margin">
            <EGoldHeaderNav title={HeaderTitle.ORDERS}/>
            {renderOrderList(props.transactions)}
        </div>
    );
}

function renderOrderList(transactions: IGoldTransactions[]) {
    return(
        <div className="order-list-container mt-3">
            {
                transactions.length > 0 ? transactions.map((value, index) => {
                    return(
                        <Link key={index}
                              to={{pathname: `${indexPath}${routePaths.ORDER_DETAILS}`,
                                  query: {transaction_id: value.transaction_id, txn_type: value.type}}}>
                        <div className="d-flex align-items-center list-items">
                            <div className="order-icon">
                                <img src={`${imageBaseUrl}/img/icons/eGold/gold-order.svg`} style={{width: "30px"}}/>
                            </div>
                            <div className="ml-2">
                                <p className="title m-0">{capitalizeFirstLetter(value.type)} Gold</p>
                                <p className="date m-0">{convertUTCtoLocalString(value.txn_date)}</p>
                            </div>
                            {
                                value.price &&
                                <div className="ml-auto text-right">
                                    <p className="amount m-0">
                                        <i className="fa fa-inr price-icon-small" aria-hidden="true"/>&nbsp;
                                        {value.price}
                                    </p>
                                    <p className="weight m-0">{value.gold_amount}gm</p>
                                </div>
                            }
                        </div>
                            <hr className=""/>
                        </Link>
                    );
                }) : renderEmptyMessage(`${imageBaseUrl}/img/order-waiting.webp`,
                    "We are waiting for your order",
                    "Start buying gold and secure your future",
                )
            }
        </div>
    );
}

const mapStateToProps = (state: IReduxState): IConnectProps =>  {
    return {
        transactions: state.eGold.transactions,
        eGoldUserDetails: state.eGold.eGoldUserDetails,
        isAndroid: state.login.isAndroid,
    };
};
export default connect<IConnectProps, {}, {}>(mapStateToProps)(Orders);
